// extracted by mini-css-extract-plugin
export var wrapper = "gallery-section-module--wrapper--joPos";